<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import { WordOfTheDay } from '@ilteducation/games';
import useWordOfTheDayStore from '@ilteducation/games/src/wotd/store';

const router = useRouter();
const store = useWordOfTheDayStore();
const { gameState } = storeToRefs(store);

const handleBack = () => {
  if (gameState.value === 'game' || gameState.value === 'game-over') {
    store.clear();
  } else {
    router.push('/games');
  }
};
</script>
<template>
  <div class="word-of-the-day-game">
    <WordOfTheDay @go-back="handleBack" />
  </div>
</template>
